<template>
  <b-form
    @submit.prevent="
      $emit('ok', {
        interruptTreatment,
        excludeFromAnalysis,
        resubmissionInDays,
        reasonForDropout,
        reasonForExclusion,
      })
    "
  >
    <b-form-checkbox
      v-model="interruptTreatment"
      :value="true"
      :unchecked-value="false"
      @change="
        $emit('input', {
          interruptTreatment,
          excludeFromAnalysis,
          resubmissionInDays,
          reasonForDropout,
          reasonForExclusion,
        })
      "
      >interrupt treatment, patient should drop out now</b-form-checkbox
    >
    <b-form-checkbox
      v-model="excludeFromAnalysis"
      :value="true"
      :unchecked-value="false"
      @change="
        $emit('input', {
          interruptTreatment,
          excludeFromAnalysis,
          resubmissionInDays,
          reasonForDropout,
          reasonForExclusion,
        })
      "
      >this case should be excluded from the scientific analysis</b-form-checkbox
    >
    <b-form-group label="- come back to this decision in … days (0 if deciding now)">
      <b-form-input
        type="number"
        v-model.number="resubmissionInDays"
        min="0"
        @input="
          $emit('input', {
            interruptTreatment,
            excludeFromAnalysis,
            resubmissionInDays,
            reasonForDropout,
            reasonForExclusion,
          })
        "
      />
    </b-form-group>
    <b-form-group label="Reason for dropout">
      <b-textarea
        v-model="reasonForDropout"
        @input="
          $emit('input', {
            interruptTreatment,
            excludeFromAnalysis,
            resubmissionInDays,
            reasonForDropout,
            reasonForExclusion,
          })
        "
      />
      <div>You can fill in a number for some of the most common reasons:</div>
      <ol>
        <li>Unknown reason as patient could not be contacted</li>
        <li>Technical Problems (e.g. no more power supply, no internet, no computer)</li>
        <li>Patient has no more time or is too busy to complete all modules</li>
        <li>Patient does not have privacy to complete treatment</li>
        <li>
          Patient accessing other type of treatment (e.g., psychological help, medication,
          psychiatry; only if patient wants to terminate treatment)
        </li>
        <li>
          Patient reported a significant reduction in symptoms/Patient sees no more need for
          treatment
        </li>
        <li>
          Patient experiencing other problems/issues that interfered with scope of treatment (e.g.
          death in the family, moving to another city, exams, other symptoms dominant)
        </li>
        <li>
          Patient does not find web-based treatment suitable (e.g., difficulties understanding
          instructions, difficulties with writing)
        </li>
        <li>Motivational problems</li>
      </ol>
    </b-form-group>
    <b-form-group label="Reason for exclusion from the scientific analysis">
      <b-textarea
        v-model="reasonForExclusion"
        @input="
          $emit('input', {
            interruptTreatment,
            excludeFromAnalysis,
            resubmissionInDays,
            reasonForDropout,
            reasonForExclusion,
          })
        "
      />
      <div>You can fill in a number for some of the most common reasons:</div>
      <ol>
        <li>Additional face-to-face therapy</li>
        <li>Change in medication</li>
        <li>Suicidal tendencies or clinical risk</li>
        <li>Psychotic tendencies</li>
      </ol>
    </b-form-group>
    <portal to="task-modal-footer">
      <div slot-scope="{ cancel, ok }">
        <b-button class="m-1" type="button" variant="secondary" @click="cancel()">Cancel</b-button>
        <b-button
          class="m-1"
          type="button"
          variant="primary"
          @click="
            $emit('input', {
              interruptTreatment,
              excludeFromAnalysis,
              resubmissionInDays,
              reasonForDropout,
              reasonForExclusion,
            })
            ok()
          "
          >OK</b-button
        >
      </div>
    </portal>
  </b-form>
</template>

<script>
export default {
  data() {
    return {
      interruptTreatment: this.value.interruptTreatment === true,
      excludeFromAnalysis: this.value.excludeFromAnalysis === true,
      resubmissionInDays: this.value.resubmissionInDays || 0,
      reasonForDropout: this.value.reasonForDropout || null,
      reasonForExclusion: this.value.reasonForExclusion || null,
    }
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
}
</script>
